import React, {FC, useEffect, useState} from 'react';
import {Markdown} from 'components/Markdown';
import {Citation} from 'templates/reports/types';

import CloseIcon from './close-black.svg';

import * as styles from './styles.module.scss';

type CitationProps = {
    citations?: Citation
	parentOpen: boolean
	openParent: () => void
}

const _Citation: FC<CitationProps> = ({
	citations,
	parentOpen,
	openParent,
}) => {
	const [open, setOpen] = useState(false);
	const onClick = () => {
		// If already open, close citations
		// but leave the parent alone
		if (open) {
			setOpen(false);
			return;
		}

		// We want to open, make sure the parent
		// is open and then set our local to open
		if (!parentOpen) openParent();
		setOpen(true);
	};

	// If the parent closes, update local state
	useEffect(() => {
		if (open && !parentOpen) {
			setOpen(false);
		}
	}, [open, parentOpen]);

	// If no citations, nothing needed
	if (!citations) {
		return null;
	}

	const link = (
		<div className={styles.link} onClick={onClick}>
			<span>See sources & methodology.</span>
		</div>
	);

	// If not open, only show link
	if (!open || !parentOpen) {
		return link;
	}

	// Otherwise, render link and block
	return (
		<>
			{link}
			<div className={styles.wrapper}>
				<div className={styles.header}>
					<div>Sources & Methodology</div>
					<img src={CloseIcon as string} onClick={onClick} />
				</div>
				<div className={styles.content}>
					{citations.methodology && (
						<div>{citations.methodology}</div>
					)}
					<h6>Sources:</h6>
					<div className={styles.sources}>
						{citations.papers.map((c, i) => (
							<Markdown markdown={c} key={i} />
						))}
					</div>
				</div>
				<div>{citations.disclaimer}</div>
				<span className={styles.close} onClick={onClick}>
					Close sources & methodology
				</span>
			</div>
		</>
	);
};

export default _Citation;
